import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { ReportsFuncionariosForm } from "../../../schemas/Funcionarios_lista/reports_funcionarios";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { FuncionarioSetorDropDown } from "../../../../domain/models/funcionario_setor_dropdown";
import { FuncionarioNomeDropDown } from "../../../../domain/models/funcionario_nome_dropdown";
import { FuncionarioFilialDropDown } from "../../../../domain/models/funcionario_filial_dropdown";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { FormRangeDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_range_picker_input";

import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * ReportsFuncionarios
 */

type Props = {
  open: boolean,
  saving: boolean,
  loading: boolean,
  funcionarioNomesLista: FuncionarioNomeDropDown[],
  funcionarioSetoresLista: FuncionarioSetorDropDown[],
  funcionarioFiliaisLista: FuncionarioFilialDropDown[],
  centroCustoLista: CentroCustoDropDown[],
  onClose: () => void,
  onSubmit: (form: ReportsFuncionariosForm) => void,
};

export const ReportsFuncionarios = ({
  open,
  saving,
  loading,
  funcionarioNomesLista,
  funcionarioSetoresLista,
  funcionarioFiliaisLista,
  centroCustoLista,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ReportsFuncionariosForm>({});

  useEffect(() => {
    if (open) hookForm.reset();
  }, [hookForm, open]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(onSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "80rem",
          },
        },
      }}>
      <DialogTitle>
        Relatório Funcionários
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={loading || saving}>
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>
              <DefaultFormMultiAutocomplete
                name='nome'
                label='Nome'
                options={funcionarioNomesLista}
                getOptionKey={x => x.idFuncionario}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm} />

              <DefaultFormMultiAutocomplete
                name='status'
                label='Status'
                options={[{ id: 0, nome: 'Ativos' }, { id: 1, nome: 'Afastados' }, { id: 2, nome: 'Demitidos' }]}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm} />

              <DefaultFormMultiAutocomplete
                name='setor'
                label='Setor'
                options={funcionarioSetoresLista}
                getOptionKey={(x) => x.setor}
                getOptionLabel={(x) => x.setor}
                reactHookForm={hookForm} />

              <DefaultFormMultiAutocomplete
                name='filial'
                label='Filial'
                options={funcionarioFiliaisLista}
                getOptionKey={(x) => x.filial}
                getOptionLabel={(x) => x.filial}
                reactHookForm={hookForm} />

              <FormRangeDatePickerInput
                label='Admissão'
                name='dataAdmissao'
                reactHookForm={hookForm}
              />

              <FormRangeDatePickerInput
                label='Demissão'
                name='dataDemissao'
                reactHookForm={hookForm}
              />

              <DefaultFormMultiAutocomplete
                name='centroCusto'
                label='Centro de Custo'
                options={centroCustoLista}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.title}
                reactHookForm={hookForm} />

              <FormRangeDatePickerInput
                label='Férias'
                name='dataFerias'
                reactHookForm={hookForm}
              />

            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              <PrimaryButton
                type="submit"
                buttonColor="primary-green">
                Gerar
              </PrimaryButton>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}